import React from "react";
import Sidebar from "components/Sidebar/Sidebar";
import { NavLink } from "react-router";
import SidebarHeader from "components/Sidebar/SidebarHeader";
import {
  isAuthenticated,
  isIkanoUser,
  isDeveloperToolsUser,
  isRestAPIUser,
  isWsAPIUser,
} from "services/self";

function SideNav() {
  return (
    <Sidebar>
      <SidebarHeader>Documentation</SidebarHeader>
      {isRestAPIUser() && (
        <NavLink to="/documentation/rest-apis" className="item link">
          REST APIs
        </NavLink>
      )}
      {isWsAPIUser() && (
        <NavLink to="/documentation/websocket-apis" className="item link">
          WebSocket APIs
        </NavLink>
      )}
      {isIkanoUser() && (
        <NavLink to="/documentation/event-based-apis" className="item link">
          Event based APIs
        </NavLink>
      )}
      {(isRestAPIUser() || isWsAPIUser()) && (
        <NavLink to="/documentation/endpoint-security" className="item link">
          Endpoint Security
        </NavLink>
      )}
      {isIkanoUser() && (
        <NavLink to="/documentation/elk-monitoring" className="item link">
          ELK Monitoring
        </NavLink>
      )}
      {isAuthenticated() && (
        <NavLink
          to="/documentation/websocket-test-client"
          className="item link"
        >
          WebSocket Test Client
        </NavLink>
      )}
      {isDeveloperToolsUser() && (
        <NavLink to="/documentation/api-gw-self-service" className="item link">
          API GW Self-Service
        </NavLink>
      )}
      {isDeveloperToolsUser() && (
        <NavLink
          to="/documentation/api-specification-editor"
          className="item link"
        >
          API Specification Editor
        </NavLink>
      )}
      {isAuthenticated() && (
        <NavLink to="/documentation/json-yaml-editor" className="item link">
          JSON/YAML Editor
        </NavLink>
      )}
    </Sidebar>
  );
}

export default SideNav;
